function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 6,
  fill: "#FF5F56",
  stroke: "#E0443E",
  strokeWidth: 0.5
}), React.createElement("circle", {
  cx: 26,
  cy: 6,
  r: 6,
  fill: "#FFBD2E",
  stroke: "#DEA123",
  strokeWidth: 0.5
}), React.createElement("circle", {
  cx: 46,
  cy: 6,
  r: 6,
  fill: "#27C93F",
  stroke: "#1AAB29",
  strokeWidth: 0.5
}));

var SvgWc = function SvgWc(props) {
  return React.createElement("svg", _extends({
    width: 54,
    height: 14,
    viewBox: "0 0 54 14"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/wc.af3f82ad.svg";
export { SvgWc as ReactComponent };